import { useTranslation } from "react-i18next";
import Hooks from "../../utils/hooks";
import {InputText} from "@empreinte/components.input-text"
import {TextArea} from "@empreinte/components.text-area"
import "../../AuthorizedIP.scss";
import { useDispatch } from "react-redux";
import { setAddAuthorizedIPActions } from "../../store/AuthorizedIPActions";
import { useState } from "react";
import { useAppSelector } from "../../../../Redux/hooks";
// const { TextArea } = Input;

const AddEditAuthorizedIP = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const { values,disabledButton} = Hooks();
  const [ipAddress, setIpAddress] = useState("");
  const [,setDescription] = useState("");
  const [ipError, setIpError] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const showDivCondition =useAppSelector((state:any) =>state.AuthorizedIPReducer.showDivsConditionsAuthorizedIP)


  const handleValidation = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
  
    if (name === "ip") {
      const reg = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
      const isValidIp = value.match(reg);
      setIpAddress(value);
  
      if (!value.trim()) {
        setIpError(t('boitier.AuthorizedIP.msgErrorRequired'));;
        disabledButton("enabled");
      } else if (!isValidIp) {
        setIpError(t('boitier.AuthorizedIP.msgErrorIp'));
        disabledButton("enabled");
      } else {
        setIpError("");
        disabledButton(showDivCondition.addAuthorizedIP && !descriptionError ? "disabled" : "enabled");
      }
  
      if (showDivCondition.editAuthorizedIP && isValidIp) {
        disabledButton("disabled");
      }
    } else {
      setDescription(value);
      setDescriptionError(value.length === 0);
  
      if (showDivCondition.editAuthorizedIP && (value.length > 0 || ipAddress !== values?.ip)) {
        disabledButton("disabled");
      } else {
        disabledButton(showDivCondition.editAuthorizedIP ? "enabled" : (showDivCondition.addAuthorizedIP && !ipError && ipAddress !== "") ? "disabled" : "enabled");
      }
    }
  
    dispatch(
      setAddAuthorizedIPActions({
        addAuthorizedIPConstraintsDataNameChange: name,
        addAuthorizedIPConstraintsDataValueChange: value,
      })
    );
  };
  
  
  
  
  return (
    <>
      <div className="addEditCard">
        <InputText
         style={{display: "none",width : '100%' , marginLeft : '2%' , marginBottom : '2%' , marginTop:'2%'}}
         value={values.name}
          id={"id"}
          name="id"

        ></InputText>
        <InputText
         className="label"
          value={values?.ip}
          name={"ip"}
          id={"ip"}
          handleChange={handleValidation}
          placeholder={t("boitier.AuthorizedIP.Header.ip")}
          labelInput= {t("boitier.AuthorizedIP.Header.ip")}
          required
        ></InputText>
      {ipError && <p className="errorMsg">{ipError}</p>}
       <TextArea
         fullWidth={true}
         className="area"
         value={values?.description}
          name="description"
          placeholder="Description"
          row={4}
          id={"description"}
          labelInput={t("boitier.AuthorizedIP.Header.description")}
          handleChange={handleValidation}
        ></TextArea>
      </div>
    </>
  );
};
export default AddEditAuthorizedIP;
